"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/*
 * Jira Ticket:
 * Created Date: Mon, 18th Nov 2019, 15:06:27 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2019 The Distance
 */
var isNewPasswordRequired = function isNewPasswordRequired() {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return user.challengeName === 'NEW_PASSWORD_REQUIRED';
};

var _default = isNewPasswordRequired;
exports.default = _default;